import { Phase } from '@/state/types.ts';
import type { ScreenRenderer } from './types.ts';
import { renderOnboarding } from './onboarding.ts';
import { renderContext } from './context.ts';
import { renderBaseline } from './baseline.ts';
import { renderClipPlay } from './clip-play.ts';
import { renderClipCheckin } from './clip-checkin.ts';
import { renderSilence } from './silence.ts';
import { renderSilenceCheckin } from './silence-checkin.ts';
import { renderInsight } from './insight.ts';
import { renderShiftChoice } from './shift-choice.ts';
import { renderReflection } from './reflection.ts';
import { renderSummary } from './summary.ts';
import { renderGuidance } from './guidance.ts';

export const screens: Record<Phase, ScreenRenderer> = {
  [Phase.ONBOARDING]: renderOnboarding,
  [Phase.CONTEXT]: renderContext,
  [Phase.BASELINE]: renderBaseline,
  [Phase.CLIP_PLAY]: renderClipPlay,
  [Phase.CLIP_CHECKIN]: renderClipCheckin,
  [Phase.SILENCE]: renderSilence,
  [Phase.SILENCE_CHECKIN]: renderSilenceCheckin,
  [Phase.INSIGHT]: renderInsight,
  [Phase.SHIFT_CHOICE]: renderShiftChoice,
  [Phase.REFLECTION]: renderReflection,
  [Phase.SUMMARY]: renderSummary,
  [Phase.GUIDANCE]: renderGuidance,
};
